<form class="qualification-tab-form" [formGroup]="LicenseTab">
  <div fxLayout="row" class='stateBoardLicensing'>
    <p class='stateBoardText'>State Board For Licensing Contractors</p>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-checkbox (click)="OnActiveStateCheck" formControlName="hasActiveStateLicense" class="mailingAddress">{{stateBoardLicensingText}}
    </mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="address-width">
      <mat-label>State License #</mat-label>
      <input matInput type="text" pattern="[0-9]*" placeholder="State License #" formControlName="stateLicenseNumber" value=""> 
   <!--  <input matInput placeholder="State License #" formControlName="stateLicenseNumber" value=""> -->
    </mat-form-field>
    <mat-form-field class="expirationWidth">
      <input matInput [matDatepicker]="picker2" formControlName="stateLicenseExpirationDate"
        placeholder="Expiration Date">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
  </div>
  <div fxLayout="row" class='stateBoardLicensing'>
    <p class='stateBoardText'>County Business License</p>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <span class="mailingAddress">{{countyBusiness}}</span>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="address-width">
      <mat-label>County License #</mat-label>
      <input matInput placeholder="County License #" formControlName="countyLicenseNumber" value="">
    </mat-form-field>
    <mat-form-field class="expirationWidth">
      <input matInput [matDatepicker]="picker3" formControlName="countyLicenseExpirationDate"
        placeholder="Expiration Date">
      <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
      <mat-datepicker #picker3></mat-datepicker>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="address-width">
      <mat-label class="boldlabel">County</mat-label>
      <mat-select formControlName="county">
        <input mat-input (keyup)="onCountyKey($event)">
        <mat-option *ngFor="let rl of filterCountyTypes" [value]="rl.id">
          {{rl?.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="row" class='stateBoardLicensing'>
    <p class='stateBoardText'>City Business License</p>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <span class="mailingAddress">{{cityBusiness}}</span>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="address-width">
      <mat-label>City License #</mat-label>
      <input matInput placeholder="City License #" formControlName="cityLicenseNumber" value="">
    </mat-form-field>
    <mat-form-field class="expirationWidth">
      <input matInput [matDatepicker]="picker4" formControlName="cityLicenseExpirationDate"
        placeholder="Expiration Date">
      <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
      <mat-datepicker #picker4></mat-datepicker>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="address-width">
      <mat-label class="boldlabel">City</mat-label>
      <mat-select formControlName="city">
        <input mat-input (keyup)="onKey($event)">
        <mat-option *ngFor="let rl of filterCities" [value]="rl.id">
          {{rl?.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>
